
import { useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import Modal from '../Modal'
import { Edit2, Trash2 } from "lucide-react";
import styled from "styled-components"
import { X } from "lucide-react"

import ModalEditProduct from '../ModalEditProduct'
import {
  TableContainer,
  TableHeader,
  TableTitle,
  AddButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ResponsiveTableWrapper,
} from "./styled/Table"
import { useNavigate } from "react-router-dom";
import { API } from "../FormEdit";
import toast from "react-hot-toast";

const ModalContent = styled(motion.div)`
  background-color: #2A2B2E;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const ModalTitle = styled.h2`
  color: #FFFFFF;
  margin: 0;
`

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`
const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 1.5rem;
`

export const ProductTable = ({
  products,
  onDeleteProduct
}) => {
  const [editingProduct, setEditingProduct] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [productos, setProductos] = useState(products)
  const [open, setOpen] = useState(false)
  const [deleteProduct,setDelete] = useState(null)
  const navigate = useNavigate()
  const tableVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  }

  useEffect(() => {
    setProductos(products)
  }, [products])

  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
    hover: { scale: 1.01 },
  }

  const handleEdit = (product) => {
    navigate(`/administracion/edit/${product.id}`)
  }

  const handleDelete = (productId) => {
    setDelete(productId)
    setIsDeleteModalOpen(true)
  }
  function confirmDelete(){
    fetch(`${API}/api/productos/${deleteProduct}`,{
      method: 'DELETE'
    }).then(res => res.json())
    .then(data => {
      setProductos(products.filter(product => product.id != deleteProduct))
      setIsDeleteModalOpen(false)
      toast.success('Producto eliminado con éxito')
    })
    .catch(err => {
      toast.error('Error al eliminar el producto')
    })
  }
  console.log(products)
  return (
    <>
      <TableContainer initial="hidden" animate="visible" variants={tableVariants}>
        <TableHeader>
          <TableTitle>Productos</TableTitle>
          <AddButton whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigate("/administracion/create/")}>
            Agregar Producto
          </AddButton>
          <Modal isOpen={open}
            onClose={() => setOpen(false)} />
        </TableHeader>
        <ResponsiveTableWrapper>
          <Table>
            <TableHead>
              <tr>
                <TableCell as="th">IMAGEN</TableCell>
                <TableCell as="th">NOMBRE</TableCell>
                <TableCell as="th">SKU</TableCell>
                <TableCell as="th">ESTADO</TableCell>
                <TableCell as="th">PRECIO</TableCell>
                <TableCell as="th">CATEGORIAS</TableCell>
                <TableCell as="th">COLORES</TableCell>
                <TableCell as="th">FECHA</TableCell>
                <TableCell as="th">ACCIONES</TableCell>
              </tr>
            </TableHead>
            <TableBody>
              <AnimatePresence>

                {productos?.map((product, idx) => {
                  const images = typeof product?.img === "string" ? JSON.parse(product?.img) : product?.img;
                  return (
                    <TableRow key={product.id} variants={rowVariants} whileHover="hover" layout>
                      <TableCell data-label="Imagen">
                        <img src={images ? images?.find(img => img?.isPrimary == "true" || true)?.url?.secure_url : images[0].url.secure_url} alt={product?.nombre} style={{ width: 40, height: 40, borderRadius: 4 }} />
                      </TableCell>
                      <TableCell data-label="Nombre">{product?.nombre}</TableCell>
                      <TableCell data-label="SKU">{product?.sku}</TableCell>
                      <TableCell data-label="Estado">{product?.status == 0 ? "Activo" : "Inactivo"}</TableCell>
                      <TableCell data-label="Precio">
                        {new Intl.NumberFormat("es-CO", {
                          style: "currency",
                          currency: "COP",
                        }).format(product?.precio)}
                      </TableCell>
                      <TableCell data-label="Categorías">{product?.categorias}</TableCell>
                      <TableCell data-label="Colores">
                        <div style={{ display: "flex", gap: 4, flexWrap: "wrap", maxWidth: "100%" }}>
                          {JSON.parse(product?.colores)?.map((color, index) => (
                            <div
                              key={index}
                              style={{
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                background: color,
                                border: "2px solid rgba(255,255,255,0.1)",
                              }}
                            />
                          ))}
                        </div>
                      </TableCell>
                      <TableCell data-label="Fecha">{product.fecha}</TableCell>
                      <TableCell data-label="Acciones">
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            onClick={() => handleEdit(product)}
                            style={{ background: "none", border: "none", cursor: "pointer" }}
                          >
                            <Edit2 size={18} color="#4A88F3" />
                          </button>
                          <button
                            onClick={() => handleDelete(product?.id)}
                            style={{ background: "none", border: "none", cursor: "pointer" }}
                          >
                            <Trash2 size={18} color="#FF4444" />
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </AnimatePresence>
            </TableBody>
          </Table>
        </ResponsiveTableWrapper>

      </TableContainer>
      {isDeleteModalOpen && (
          <ModalOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <ModalContent
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
            >
              <ModalHeader>
                <ModalTitle>Confirmar Eliminación</ModalTitle>
                <CloseButton onClick={() => setIsDeleteModalOpen(false)}>
                  <X size={24} />
                </CloseButton>
              </ModalHeader>
              <p style={{ color: "#FFFFFF", marginBottom: "20px" }}>
                ¿Estás seguro de que quieres eliminar este Producto?
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <Button onClick={() => setIsDeleteModalOpen(false)}>Cancelar</Button>
                <Button onClick={() => confirmDelete()} style={{ backgroundColor: "#FF4444" }}>
                  Eliminar
                </Button>
              </div>
            </ModalContent>
          </ModalOverlay>
        )}

    </>
  )
}

